import React, {useState} from 'react';
import styles from '../styles/pages/Home.module.css';
import CreateNewLearningPath from '../components/learningPathManagement/createNewLearningPath';

const CreateLearningPath = () => {
  return (
    <div className="page_content">
      <div className={styles.container}>
        <main className={styles.main}>
          {/* <SideNavigationComponent pageName="CONTENT-MANAGEMENT" {...props} /> */}
          <CreateNewLearningPath />
        </main>
      </div>
    </div>
  );
};

CreateLearningPath.propTypes = {};

export default CreateLearningPath;
